const assetsApi = ({ apiClient }) => ({
  list(params = {}) {
    return apiClient.get('assets', {}, params, {})
  },
})

export default assetsApi
